(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sub-compare-widget"] && !Shopify.designMode) return;
  try {
    (function() {
  document.querySelectorAll('[data-scw-card]').forEach(function(card) {
    card.addEventListener('click', activateCard);
    card.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activateCard.call(this, e);
      }
    });
  });

  function activateCard() {
    var bid   = this.dataset.block;
    var type  = this.dataset.scwCard;
    var cards = document.querySelectorAll('[data-block="' + bid + '"]');
    var form  = document.getElementById('scw-form-' + bid);
    var planInput = document.getElementById('scw-plan-' + bid);

    cards.forEach(function(c) {
      var isThis = c === document.querySelector('[data-scw-card="' + type + '"][data-block="' + bid + '"]');
      c.classList.toggle('scw__card--active', isThis);
      c.setAttribute('aria-pressed', isThis ? 'true' : 'false');
      var radio = c.querySelector('.scw__radio');
      if (radio) radio.classList.toggle('scw__radio--on', isThis);
    });

    if (planInput) {
      planInput.disabled = (type !== 'sub');
    }
  }
})();
  } catch(e) { console.error(e); }
})();

})();
